import * as React from 'react';
import {Col, Container, Row} from 'reactstrap';
import StockProductoForm from './stock-producto-form';
import fileDownload from 'js-file-download';
import MiranaServiceClient from '../../../../middleware/mirana-client';
import {lazyInject, TYPES} from '../../../../utils/inversify-config';
import StockProductoTable from './stock-producto-table';
import * as moment from 'moment';
import {error, success} from '../../../../utils/notification-actions';
import {connect} from 'react-redux';
import {mirana} from '@wize/mirana-proto/mirana-proto';
import {getFileName} from '../../../../utils/utils';

interface StockProductoState {
    stockList: mirana.IUIStockProducto[];
    fecha?: string;
    fuerzaVentaId?: string;
}

class StockProducto extends React.PureComponent<ReduxProps, StockProductoState> {

    @lazyInject(TYPES.MIRANA_SERVICE)
    public apiClient: MiranaServiceClient;

    constructor(props, state) {
        super(props, state);

        this.state = {
            stockList: [],
        };

        this.handleFiltrar = this.handleFiltrar.bind(this);
        this.handleGenerarExcel = this.handleGenerarExcel.bind(this);
    };

    public async handleFiltrar(values) {
        const fecha = moment(values.fecha).format('DD/MM/YYYY');
        const fuerzaVentaId = values.fuerzaVenta ? values.fuerzaVenta.value : null;

        try {
            const response = await this.apiClient.filtrarStockSublineas(fecha, fuerzaVentaId);
            this.setState({
                stockList: response.stocks ? response.stocks : [],
                fecha,
                fuerzaVentaId
            });

            this.props.dispatch(success('Notificación', `Registros encontrados: ${this.state.stockList.length}`));
        } catch (ex) {
            this.props.dispatch(error('Error', 'Error interno al filtrar stock'));
        }
    }

    public async handleGenerarExcel() {
        const {fecha, fuerzaVentaId} = this.state;
        if (fecha) {
            const response = await this.apiClient.descargarStockSublineas(fecha, fuerzaVentaId);
            fileDownload(response.data, getFileName(response));
        }
    }

    public render() {
        return (
            <Container>
                <Row>
                    <Col md={12}>
                        <h3 className='page-title'>Stock Detallado</h3>
                    </Col>
                </Row>
                <Row>
                    <Col md={3}>
                        <StockProductoForm onSubmit={this.handleFiltrar}/>
                    </Col>
                    <Col md={9}>
                        <StockProductoTable handleGenerarExcel={this.handleGenerarExcel}
                                            stockList={this.state.stockList}
                                            fechaCarga={this.state.fecha}/>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default connect()(StockProducto);



// WEBPACK FOOTER //
// ./src/components/pages/stock/producto/stock-producto.tsx